class SystemClock {

    private _timeout: number;
    private _stopped: boolean;
    private _interval: number;
    private _tick: () => void;


    constructor(interval: number = 1000) {

        this._timeout = null;
        this._stopped = true;
        this._interval = interval;

        this._tick = () => {};
    }

    setTick(func) {
        this._tick = func;
    }

    /**
     * @param {number} val
     */
    setInterval(val = 1000) {
        this._interval = val;
    }

    /**
     * @param {?boolean} force
     */
    start(force = true) {

        if(this._stopped && !force) {
            return;
        }

        this._stopped = false;

        this._tick();

        this._timeout = setTimeout(this.start.bind(this, false), this._interval);
    }

    stop() {
        this._timeout && clearTimeout(this._timeout);
        this._stopped = true;
    }

    reset() {
        this.stop();
        this.start(true);
    }
}

export default SystemClock;